<!--
  An ElFrom inside an ElFormSmallItem
  the item is validated only if the form is fully validated
-->

<template>
  <el-form-small-item
    :prop="prop"
    :required="required"
    :rules="computedRules"
    :validate-status="validateStatus"
    :show-message="false"
    :field="field">
    <el-form ref="form"
      :model="computedModel"
      :rules="formRules"
      v-bind="$attrs"
      v-on="$listeners">
      <slot></slot>
    </el-form>
  </el-form-small-item>
</template>

<script>
import ElFormSmallItem from './ElFormSmallItem.vue'

export default {
  name: 'ElFormSub',

  componentName: 'ElFormSub',

  components: {
    ElFormSmallItem,
  },

  props: {
    prop: String,
    required: {
      type: Boolean,
      default: undefined,
    },
    validateStatus: String,
    showMessage: {
      type: Boolean,
      default: true,
    },
    rules: Object,
    // the rules of the form
    formRules: Object,
    // the name to display in error messages
    field: String,
    model: Object,
  },

  data () {
    return {
      itemValidator: { validator: this.validator, trigger: 'submit' },
      valid: true,
      tempModel: undefined,
    }
  },

  computed: {
    computedRules () {
      return [this.itemValidator].concat(this.rules || [])
    },
    computedModel () {
      return this.model || (this.prop ? this.tempModel || {} : undefined)
    },
  },

  methods: {
    validator (rule, value, callback) {
      this.tempModel = value
      this.$nextTick(() => this.validate((valid, errors) => callback(errors)))
    },

    validate (callback) {
      let promise = callback ? undefined : new Promise((resolve, reject) => {
        callback = (valid, errors) => valid ? resolve() : reject(errors)
      })
      this.$refs.form.validate((valid, errors) => {
        this.valid = valid
        if (valid) errors = undefined
        callback(valid, errors)
        this.$emit('valid', valid, errors)
      })
      return promise
    },
  },
}
</script>
